export default __webpack_public_path__ + "static/media/landing_KOR_01.a224f6bc.png";